import React, { Component } from 'react'
import { MDBCol, MDBSelect, MDBContainer, MDBRow, MDBBtn } from 'mdb-react-ui-kit'
import { Subscription } from 'rxjs'
import { toast } from 'react-toastify'
import TrainingsPageService from './../../shared/TrainingsPage.service'
import { UIInput, UISelect } from './../../../../components/forms/form-fields'

import './TrainingVideoForm.scss'

const outputOpts = [
  { text: 'Video Player', value: 'player' },
  { text: 'External Link', value: 'external_link' },
]

const TRAINING_FILTER_OPTS = {
  spec: ['HEALTH', 'SENIOR', 'LIFE'],
  onboarding: ['sig_agent', 'career_agent'], //, 'associate_agent', 'affiliate_agent']
}

class TrainingVideoForm extends Component {
  state = {
    trainingTypes: [],
    errorsExist: false,
    saving: false,
    training: {
      id: null,
      training_name: '',
      training_link: '',
      training_type_id: null,
      training_order: '',
      training_code: '',
      training_age: null,
      training_output: '',
      training_filters: {
        spec: [],
      },
      is_required: 0,
      requires_quiz: 0,
    },
    order: {
      from: null,
      to: null,
    },
  }

  _errors = {}
  __subscriptions$ = new Subscription()

  componentDidMount() {
    this.__subscriptions$.add(
      TrainingsPageService.fetchTrainingTypes().subscribe(types => this._setTrainingTypes(types))
    )

    if (this.props.training && typeof this.props.training === 'object' && Object.keys(this.props.training).length) {
      let filters = this.props.training.training_filters
      if (filters && typeof filters === 'string') {
        try {
          filters = JSON.parse(filters)
        } catch (e) {
          filters = {}
        }
      }
      if (!filters || typeof filters !== 'object') filters = {}
      const spec = Array.isArray(filters.spec) ? filters.spec : []
      const onboarding = Array.isArray(filters.onboarding) ? filters.onboarding : []

      this.setState({
        training: {
          ...this.props.training,
          training_filters: { spec, onboarding },
        },
        order: {
          from: this.props.training?.training_order || 999,
          to: this.props.training?.training_order || 999,
        },
      })
    }
  }

  componentWillUnmount() {
    this.__subscriptions$.unsubscribe()
  }

  _setTrainingTypes = types => this.setState({ trainingTypes: Array.isArray(types) ? types : [] })

  _renderErrorField = field => {
    if (field && this._errors.hasOwnProperty(field) && this.state.errorsExist)
      return <span className='error-msg'>{this._errors[field]}</span>
    return <></>
  }

  _onChange = event => {
    const field = event.target.name,
      order = this.state.order

    if (
      (typeof this.state.training[field] === 'object' &&
        JSON.stringify(this.state.training[field]) === JSON.stringify(event.target.value)) ||
      (typeof this.state.training[field] !== 'object' && `${this.state.training[field]}` === `${event.target.value}`)
    )
      return

    let training = { ...this.state.training }
    training[field] = event.target.value

    if (field === 'training_code') {
      training.is_required =
        training[field] && `${training[field]}`.trim().length > 0
          ? parseInt(training.is_required) === 0
            ? 1
            : training.is_required
          : parseInt(training.is_required) === 1
          ? 0
          : training.is_required
    } else if (field === 'training_order') {
      if (training[field] && !isNaN(training[field])) order.to = parseInt(training[field])
    }

    this.setState({ training, order })
  }

  _isValid = () => {
    let errors = {}
    Object.keys(this.state.training).forEach(field => {
      switch (field) {
        case 'training_name':
        case 'training_link':
        case 'training_type_id':
        case 'training_output':
          if (!this.state.training[field] || !`${this.state.training[field]}`.trim().length) errors[field] = 'Required.'
          break
        case 'training_order':
          if (!this.state.training[field] || !`${this.state.training[field]}`.trim().length) errors[field] = 'Required.'
          else if (!new RegExp(/^\d+$/).test(`${this.state.training[field]}`.trim())) errors[field] = 'Invalid.'
          break
        case 'training_code':
          if (!this.state.training[field] || !`${this.state.training[field]}`.trim().length) break
          if (`${this.state.training[field]}`.trim().length < 6) errors[field] = 'Too short.'
          else if (`${this.state.training[field]}`.trim().length > 6) errors[field] = 'Too long.'
          else if (!new RegExp(/^[A-Za-z0-9]{6}$/).test(`${this.state.training[field]}`.trim()))
            errors[field] = 'Invalid.'
          break
        case 'training_age':
          if (this.state.training[field] === null || this.state.training[field] === '') break
          if (this.state.training[field] <= 0) {
            errors[field] = 'Days to Retain can not be 0 or negative.'
            break
          }
          if (!Number.isInteger(this.state.training[field] * 1)) {
            errors[field] = 'Days to Retain should be an integer.'
            break
          }
          break
        default:
          break
      }
    })

    this._errors = errors

    if (Object.keys(errors).length === 0) {
      if (this.state.errorsExist) this.setState({ errorsExist: false })
      return true
    }

    if (!this.state.errorsExist) this.setState({ errorsExist: true })

    return false
  }

  _onSubmit = () => {
    if (!this._isValid()) return

    this.setState({ saving: true })
    try {
      parseInt(this.state.training.id) > 0
        ? TrainingsPageService.updateTraining(
            this.state.training.id,
            {
              ...this.state.training,
              training_filters: JSON.stringify({
                ...(typeof this.props.training.training_filters === 'string'
                  ? JSON.parse(this.props.training.training_filters)
                  : this.props.training.training_filters),
                ...this.state.training.training_filters,
              }),
            },
            this.state.order.from !== this.state.order.to ? this.state.order : null
          )
        : TrainingsPageService.createTraining({
            ...this.state.training,
            training_filters: JSON.stringify(this.state.training.training_filters),
          })
      toast.success('Training video saved.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } catch (ex) {
      toast.error('An error occurred attempting to save the training video.  ' + ex, {
        position: toast.POSITION.TOP_RIGHT,
      })
    }

    this.setState({ saving: false })
    return !!false
  }

  render() {
    const { saving, training } = this.state
    const trainingFilters = training?.training_filters || {}
    const spec = Array.isArray(trainingFilters.spec) ? trainingFilters.spec : []
    const onboarding = Array.isArray(trainingFilters.onboarding) ? trainingFilters.onboarding : []

    return (
      <MDBContainer id='TrainingVideoForm'>
        <MDBRow>
          <MDBCol size='12' md='4'>
            <UIInput
              label='Training Video Title'
              name='training_name'
              value={training.training_name}
              onChange={this._onChange}
              required
            />
            {this._renderErrorField('training_name')}
          </MDBCol>
          <MDBCol size='12' md='4'>
            <UISelect
              label='Training Category'
              search
              options={(Array.isArray(this.state.trainingTypes) ? this.state.trainingTypes : []).map(type => ({
                text: type.training_type_name,
                value: `${type.id}`,
              }))}
              name='training_type_id'
              value={training.training_type_id != null ? `${training.training_type_id}` : ''}
              onChange={this._onChange}
              required
            />
            {this._renderErrorField('training_type_id')}
          </MDBCol>
          <MDBCol size='12' md='4'>
            <div className='ui-input ui-input-select'>
              <MDBSelect
                label='Training Filters'
                multiple
                data={Object.keys(TRAINING_FILTER_OPTS)
                  .map(filter => {
                    const opts = TRAINING_FILTER_OPTS[filter]
                    return Array.isArray(opts)
                      ? opts.map(opt => {
                          switch (filter) {
                            case 'spec':
                              return {
                                text: `Agent Spec: ${opt}`,
                                value: opt,
                              }
                            default:
                              return {
                                text: `${filter.charAt(0).toUpperCase() + filter.toLowerCase().substr(1)}: ${opt
                                  .replace('_', ' ')
                                  .toUpperCase()}`,
                                value: opt,
                              }
                          }
                        })
                      : []
                  })
                  .flat()}
                name='training_filters'
                value={[...spec, ...onboarding]}
                onValueChange={val => {
                  const arr = Array.isArray(val) ? val : val ? [val] : []
                  const values = arr.map(i => i?.value).filter(Boolean)
                  this._onChange({
                    target: {
                      name: 'training_filters',
                      value: {
                        spec: values.filter(v => TRAINING_FILTER_OPTS.spec.includes(v)),
                        onboarding: values.filter(v => TRAINING_FILTER_OPTS.onboarding.includes(v)),
                      },
                    },
                  })
                }}
              />
            </div>
            {this._renderErrorField('training_filters')}
          </MDBCol>
          <MDBCol size='12' md='2'>
            <UISelect
              label='Is Required'
              options={[
                { text: 'No', value: '0' },
                { text: 'Yes', value: '1' },
              ]}
              name='is_required'
              value={Number(training?.is_required) === 1 ? '1' : '0'}
              onChange={e => this._onChange({ target: { name: 'is_required', value: parseInt(e.target.value) } })}
              required
            />
            {this._renderErrorField('is_required')}
          </MDBCol>
          <MDBCol size='12' md='2'>
            <UISelect
              label='Requires Quiz'
              options={[
                { text: 'No', value: '0' },
                { text: 'Yes', value: '1' },
              ]}
              name='requires_quiz'
              value={Number(training?.requires_quiz) === 1 ? '1' : '0'}
              onChange={e => this._onChange({ target: { name: 'requires_quiz', value: parseInt(e.target.value) } })}
              required
            />
            {this._renderErrorField('requires_quiz')}
          </MDBCol>
          <MDBCol size='12' md='2'>
            <UIInput label='Video Code' name='training_code' value={training.training_code} onChange={this._onChange} />
            {this._renderErrorField('training_code')}
          </MDBCol>
          {parseInt(training?.is_required) !== 1 ? (
            <MDBCol size='12' md='4'>
              <UIInput
                type='number'
                label='Days to Retain'
                name='training_age'
                value={training.training_age}
                onChange={this._onChange}
              />
              {this._renderErrorField('training_age')}
            </MDBCol>
          ) : (
            <></>
          )}
        </MDBRow>
        <MDBRow>
          <MDBCol size='12' md='6'>
            <UIInput
              label='Training Link'
              name='training_link'
              value={training.training_link}
              onChange={this._onChange}
              required
            />
            {this._renderErrorField('training_link')}
          </MDBCol>
          <MDBCol size='12' md='3'>
            <UISelect
              label='State'
              options={outputOpts}
              name='training_output'
              value={training.training_output || ''}
              onChange={this._onChange}
              required
            />
            {this._renderErrorField('training_output')}
          </MDBCol>
          <MDBCol size='12' md='3'>
            <UIInput
              label='Video Order'
              name='training_order'
              value={training.training_order}
              onChange={this._onChange}
              required
            />
            {this._renderErrorField('training_order')}
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol size='12'>
            <MDBBtn className='btn-block' color='unique' type='button' onClick={() => this._onSubmit()}>
              {saving ? 'Saving...' : 'Save'}
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    )
  }
}

export default TrainingVideoForm
